import { IconChevronLeft16 as ArrowLeft, IconChevronRight16 as ArrowRight } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { IRoundedButton } from './types';

import * as styles from './styles.css';

export const RoundedButton: FC<IRoundedButton> = props => {
  const { right, className, dataTestId, onClick } = props;
  const Icon = right ? ArrowRight : ArrowLeft;

  return (
    <button
      className={clsx(styles['root'], className, { [styles['left']]: !right })}
      data-testid={dataTestId}
      type="button"
      onClick={onClick}
    >
      <Icon color="white_100" />
    </button>
  );
};
